import { useI18n } from '@change-corgi/core/react/i18n';

import { useTopicPageData } from 'src/app/pages/topic/pageContext';

type RelatedTopicPages = ReturnType<typeof useTopicPageData>['data']['relatedTopicPages'];

type Result = ModelHookResult<{
	displayed: boolean;
	headingText: string;
	relatedTopicPages: RelatedTopicPages;
}>;

export function useRelatedTopicPages(): Result {
	const {
		data: { name, relatedTopicPages },
	} = useTopicPageData();

	const { translate } = useI18n();

	return {
		data: {
			displayed: !!relatedTopicPages.length,
			headingText: translate('corgi.topic_page.related_topics.heading', { name }),
			relatedTopicPages,
		},
	};
}
